import {GraphData} from './graph-data';
import * as _ from 'lodash-es';

export class AttendanceData extends GraphData {
    public get entitiesGroupedByLearnerAndExercise () {
        return _.groupBy(this.entities, 'attributes.uid');
    }

}
